var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import { Field } from "formik";
import FieldLayout from "./FieldLayout";
import useFormTheme from "./useFormTheme";
/**
 *
 * @param {{
 *  name: string; // The path to the field in lodash-like dot path, such as `social.facebook` or `friends[0].firstName`.
 *  label: string | JSX.Element; // The localized label.
 *  value: string;
 *  description?: string | JSX.Element; // The description.
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function CheckboxField(_a) {
    var { name, label, description } = _a, rest = __rest(_a, ["name", "label", "description"]);
    const theme = useFormTheme();
    return (_jsx(FieldLayout, { name: name, label: label, description: description, children: _jsx(Field, Object.assign({ name: name, type: "checkbox", sx: theme === null || theme === void 0 ? void 0 : theme.checkbox }, rest)) }));
}
//# sourceMappingURL=CheckboxField.js.map